// de strings for messages/paywall.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const paywall: Dict = {
  "paywall.hl.unlimitedCovers": "Unbegrenzt Cover",
  "paywall.hl.voices": "Über 93.000 Stimmen",
  "paywall.hl.downloads": "Downloads",
  "paywall.hl.duetsTts": "Duette und Text-to-Speech",
  "paywall.hl.trainVoices": "Eigene Stimmen trainieren",
  "paywall.hl.hdVideos": "Videos in 1080p",
  "paywall.hl.videoCoins": "50 Video-Coins pro Monat",
  "paywall.hl.marbleLyric": "Marble-Run- und Lyric-Videos",
  "paywall.hl.priority": "Bevorzugte Verarbeitung",
  "paywall.hl.unlimitedCoins": "Unbegrenzt Video-Coins",
  "paywall.hl.apiCredits": "$25 API-Guthaben pro Monat",
  "paywall.hl.everythingCreator": "Alles aus Creator",
  "paywall.hl.thisCover": "Dieses Cover, sofort",

  "paywall.reason.unlock.title": "Schalte dein Cover frei",
  "paywall.reason.unlock.body":
    "Stimme und Audio stehen. Abonniere und dein Cover startet sofort, in etwa einer Minute fertig. Danach erstellst du so viele, wie du willst.",
  "paywall.reason.create.title": "Dein Cover ist startklar",
  "paywall.reason.create.body":
    "Audio und Stimme sind eingerichtet. Wähl einen Plan, um es zu erstellen, und mach danach so viele Cover, wie du willst.",
  "paywall.reason.browse.title": "Erstelle Cover mit jeder Stimme",
  "paywall.reason.browse.body":
    "Unbegrenzt Cover, Downloads und alle über 93.000 Stimmen. Jederzeit kündbar.",
  "paywall.reason.credits.title": "Deine Credits sind aufgebraucht",
  "paywall.reason.credits.body":
    "Dein nächstes Cover wartet. Basic hat kein Limit, du musst also nie wieder Credits zählen.",
  "paywall.reason.words.title": "Lass die Stimme deine Worte sagen",
  "paywall.reason.words.body":
    "Tipp Text ein oder beschreib einen Song, und die Stimme singt oder spricht ihn. Ab Basic enthalten.",
  "paywall.reason.video.title": "Mach ein Video daraus",
  "paywall.reason.video.body":
    "Marble-Run- und Lyric-Videos, fertig für TikTok und Reels. Creator enthält jeden Monat 50 Video-Coins.",
  "paywall.reason.resume.title": "Mach da weiter, wo du aufgehört hast",
  "paywall.reason.resume.body":
    "Dein Plan ist gespeichert. Schließ den Checkout ab und erstelle dann so viele Cover, wie du willst.",
  "paywall.reason.train.title": "Erstelle eine Stimme, die sonst keiner hat",
  "paywall.reason.train.body":
    "Trainiere eigene Stimmen aus ein paar Aufnahmen und nutze sie in jedem Cover. Unbegrenzt mit Creator.",

  "paywall.cta.unlockFor": "Cover freischalten für {price}",
  "paywall.cta.keepGoingFor": "Weitermachen für {price}",
  "paywall.cta.backToCreatorFor": "Zurück zu Creator für {price}",
  "paywall.cta.backFor": "Zurückkommen für {price}",
  "paywall.cta.startFor": "Starten für {price}",
  "paywall.cta.startPlanFor": "{plan} starten für {price}",

  "paywall.renew.welcome":
    "{price} pro Monat, solange du dabei bist. Verlängert sich monatlich, bis du kündigst.",
  "paywall.renew.then":
    "Danach {price} pro Monat. Verlängert sich monatlich, bis du kündigst.",
  "paywall.renew.yearly":
    "{price} werden heute für 12 Monate berechnet. Verlängert sich jährlich, bis du kündigst.",

  "paywall.toast.updated": "Dein Abo wurde aktualisiert!",
  "paywall.toast.error": "Etwas ist schiefgelaufen, bitte versuch es erneut.",

  "paywall.welcomeBack": "WILLKOMMEN ZURÜCK",
  "paywall.priceMonth": "{price} pro Monat",
  "paywall.welcome.offerCreator": "Creator für {price} pro Monat",
  "paywall.welcome.card":
    "Dein Plan wurde beendet, weil eine Zahlung nicht durchging, nicht weil du gegangen bist. Mach weiter, wo du aufgehört hast, für {offer}.",
  "paywall.welcome.price":
    "Du hast gesagt, es war zu teuer, also hier für weniger: {offer} statt {was}, solange du dabei bist.",
  "paywall.welcome.broken":
    "Du hast gesagt, dass etwas nicht funktioniert hat. In der letzten Woche sind {n} von 100 Covern einwandfrei geworden. Komm zurück für {offer}.",
  "paywall.welcome.secretCreator":
    "Creator für {price} pro Monat, mit einem Plan, den wir nicht bewerben. Er bleibt dir, solange du abonniert bist.",
  "paywall.welcome.secret":
    "Alles, was du hattest, für {price} pro Monat, mit einem Plan, den wir nicht bewerben. Er bleibt dir, solange du abonniert bist.",
  "paywall.welcome.coversHere": "Deine {n} Cover sind noch da",
  "paywall.welcome.coverHere": "Dein Cover ist noch da",
  "paywall.welcome.makeAgain": "Wieder Cover erstellen",
  "paywall.ended.today": "Dein Plan ist heute abgelaufen",
  "paywall.ended.yesterday": "Dein Plan ist gestern abgelaufen",
  "paywall.ended.days": "Dein Plan ist vor {n} Tagen abgelaufen",
  "paywall.ended.months": "Dein Plan ist vor {n} Monaten abgelaufen",
  "paywall.more": "weitere",

  "paywall.recommended": "EMPFOHLEN",
  "paywall.perMonth": "pro Monat",
  "paywall.perMonthStay": "pro Monat, solange du dabei bist",
  "paywall.firstMonth": "erster Monat",
  "paywall.today": "heute",
  "paywall.heldFor": "Reserviert für {time}",
  "paywall.coverReady": "DEIN COVER IST STARTKLAR",
  "paywall.coverSetUp": "Audio und Stimme sind eingerichtet",
  "paywall.coversToday": "{n} Cover heute auf Jammable erstellt",
  "paywall.coversTodayShort": "{n} Cover heute erstellt",
  "paywall.pickPlanUnlock": "Wähl einen Plan zum Freischalten",
  "paywall.pickPlan": "Plan wählen",
  "paywall.whatYouGet": "DAS BEKOMMST DU MIT {plan}",
  "paywall.secure": "Sicherer Checkout mit Stripe · jederzeit kündbar",
  "paywall.topPlan": "Du hast unseren besten Plan",
  "paywall.managePlan": "Plan verwalten",

  "paywall.changePlan": "Plan ändern",
  "paywall.planYearly": "{plan}, jährlich",
  "paywall.planMonthly": "{plan}-Plan",
  "paywall.billedYearly": "Jährliche Abrechnung",
  "paywall.pay": "Bezahlen",
  "paywall.payUnlock": "Bezahlen und freischalten",
  "paywall.checkoutLoading": "Dein Checkout wird vorbereitet",

  "paywall.leave.title": "Ohne dein Cover gehen?",
  "paywall.leave.oneStep": "Du bist nur einen Schritt entfernt.",
  "paywall.leave.audioIn": "Dein Audio ist hochgeladen",
  "paywall.leave.voiceReady": "{names} ist bereit, es zu singen",
  "paywall.leave.voicesReady": "{names} sind bereit, es zu singen",
  "paywall.leave.voicePicked": "Deine Stimme ist gewählt",
  "paywall.leave.makeStep": "Cover erstellen: etwa eine Minute",
  "paywall.leave.gets": "FREISCHALTEN BRINGT DIR",
  "paywall.leave.held":
    "Es ist für {time} reserviert. Danach ist es weg und du müsstest es neu erstellen.",
  "paywall.unlockMyCover": "Cover freischalten",
  "paywall.leaveAnyway": "Trotzdem gehen",

  "paywall.gift.wrapping": "Wir packen etwas für dich ein…",
  "paywall.gift.beforeYouGo": "BEVOR DU GEHST",
  "paywall.gift.saved": "Wir haben ein Geschenk für dich",
  "paywall.gift.openToSee": "Öffne es, um zu sehen, was drin ist.",
  "paywall.gift.opening": "Wird geöffnet…",
  "paywall.gift.open": "Geschenk öffnen",
  "paywall.gift.noThanks": "Nein danke, gehen",
  "paywall.gift.yours": "DEIN GESCHENK",
  "paywall.gift.headline": "{plan} für {price} pro Monat",
  "paywall.gift.body":
    "Unbegrenzt Cover mit jeder Stimme, gesichert für 12 Monate.",
  "paywall.gift.save": "SPARE {pct} %",
  "paywall.perMo": "/Monat",
  "paywall.gift.billedYearly": "{price} jährlich abgerechnet",
  "paywall.gift.lockIn": "{price} pro Monat sichern",
  "paywall.seeMonthly": "Monatliche Pläne ansehen",

  "paywall.locked.step.upload": "Dein Audio wird hochgeladen",
  "paywall.locked.step.match": "Stimme wird abgestimmt",
  "paywall.locked.step.mix": "Mix wird vorbereitet",
  "paywall.locked.yourAudio": "dein Audio",
  "paywall.locked.yourAiSong": "deinen KI-Song",
  "paywall.locked.yourWords": "deinen Text",
  "paywall.locked.yourVoice": "Deine Stimme",
  "paywall.locked.startFailed":
    "Das Cover konnte nicht gestartet werden. Versuch es erneut.",
  "paywall.locked.makeNow": "Jetzt erstellen",
  "paywall.unlock": "Freischalten",
  "paywall.locked.pctDone": "{pct} % fertig",
  "paywall.locked.gettingReady": "{names} wird für {song} vorbereitet",
  "paywall.locked.done": "fertig",
  "paywall.locked.now": "läuft",
  "paywall.locked.expired": "Dieses Cover ist abgelaufen",
  "paywall.locked.expiredBody":
    "Gesperrte Cover werden 48 Stunden reserviert. Erstell es in einer Minute neu.",
  "paywall.locked.makeAgain": "Neu erstellen",
  "paywall.locked.readyToMake": "Startklar",
  "paywall.locked.readyOne": "Die KI-Stimme von {names} ist bereit für {song}",
  "paywall.locked.readyMany":
    "Die KI-Stimmen von {names} sind bereit für {song}",
  "paywall.locked.onPlan":
    "Du hast einen Plan, also kann es sofort losgehen. Es dauert etwa eine Minute.",
  "paywall.locked.unlockBody":
    "Schalte es frei und dein Cover startet sofort. Es dauert etwa eine Minute, danach kannst du es herunterladen und teilen.",
  "paywall.locked.change": "Stimme oder Audio ändern",
  "paywall.locked.notMade": "Dieses Cover wurde noch nicht erstellt",
  "paywall.locked.makeYourOwn":
    "Erstell dein eigenes mit {names} in etwa einer Minute.",
  "paywall.locked.makeCover": "Cover erstellen",

  "paywall.video.unlock": "Cover und Video\nfreischalten",
  "paywall.video.howItLooks": "So wird dein Video aussehen",
  "paywall.video.drawing": "Dein Video wird gezeichnet",
  "paywall.video.aria": "{cta}: dein Cover und das Video dazu",

  "paywall.return.firstMonth": "{price} für deinen ersten Monat",
  "paywall.return.waiting": "Dein Cover zu „{title}“ wartet",
  "paywall.return.savedWaiting": "Dein gespeichertes Cover wartet",
  "paywall.return.trialReady": "Deine 7-tägige kostenlose Testphase ist bereit",
  "paywall.return.trialDetail":
    "Heute nichts zahlen, danach {price} pro Monat. Jederzeit kündbar.",
  "paywall.return.startTrial": "Kostenlos testen",
  "paywall.return.funds":
    "Laut deiner Bank ist nicht genug Guthaben auf der Karte.",
  "paywall.return.declined": "Deine Bank hat die Zahlung abgelehnt.",
  "paywall.return.cardFailed": "Deine Karte ist nicht durchgegangen",
  "paywall.return.cardDetail":
    "Deine Karte ist nicht durchgegangen. Probier Apple Pay, Google Pay oder eine andere Karte · {price}",
  "paywall.return.whyDetail":
    "{why} Probier Apple Pay, Google Pay oder eine andere Karte · {price}",
  "paywall.return.tryAnother": "Anders bezahlen",
  "paywall.return.confirm": "Deine Bank wollte eine kurze Bestätigung",
  "paywall.return.confirmDetail":
    "Noch ein Schritt, dann bist du dabei · {price}",
  "paywall.return.finish": "Zahlung abschließen",
  "paywall.return.planHere": "Dein {plan}-Plan ist noch da",
  "paywall.return.heldMore": "Noch {time} reserviert · {price}",
  "paywall.return.thenRegular": "{price}, danach {regular}",
  "paywall.return.cancelAny": "{price}, jederzeit kündbar",
  "paywall.return.pickUp": "Da weitermachen, wo ich war",
  "paywall.return.cardStopped":
    "Dein Plan wurde beendet, weil eine Zahlung nicht durchging",
  "paywall.return.comeBack": "Komm zurück zu Jammable",
  "paywall.return.pickUpFor": "Mach weiter, wo du aufgehört hast, für {offer}.",
  "paywall.return.secretOffer":
    "Komm zurück für {offer}, mit einem Plan, den wir nicht bewerben.",
  "paywall.return.hide": "Ausblenden",
};

export default paywall;
